import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { GraphicNotifier } from './graphic-notifier';
import { GraphicState } from './graphic-state';

@Injectable()
export class GraphicProvider extends BaseProvider<GraphicNotifier, GraphicState> {
  constructor() {
    super(GraphicNotifier);
    this.trackSessionReset(() => this.notifier.resetState());
  }
}
